import { ChevronLeft, ChevronRight } from 'lucide-react'
import { Button } from '@/shared/components/ui/button'
import { cn } from '@/shared/lib/utils'

export function CursorPaginationControls({
  label,
  previousLabel,
  nextLabel,
  statusLabel,
  canPrevious,
  canNext,
  onPrevious,
  onNext,
  className,
}: {
  label: string
  previousLabel: string
  nextLabel: string
  statusLabel: string
  canPrevious: boolean
  canNext: boolean
  onPrevious: () => void
  onNext: () => void
  className?: string
}) {
  return (
    <nav aria-label={label} className={cn('flex flex-wrap items-center gap-3', className)}>
      <Button type="button" variant="outline" size="sm" disabled={!canPrevious} onClick={onPrevious}>
        <ChevronLeft className="size-4" aria-hidden />
        {previousLabel}
      </Button>
      <span className="text-sm text-muted-foreground">{statusLabel}</span>
      <Button type="button" variant="outline" size="sm" disabled={!canNext} onClick={onNext}>
        {nextLabel}
        <ChevronRight className="size-4" aria-hidden />
      </Button>
    </nav>
  )
}
